import React from "react"

import { Typography } from "@mui/material"

import { ButtonPrimary } from "../../clux-ui/components"

import "./style.scss"

interface SettingsPageLayoutProps {
  title: string
  buttonText: string
  buttonAction: Function
  children: any
}

const SettingsPageLayout = ({
  title,
  buttonText,
  buttonAction,
  children,
}: SettingsPageLayoutProps) => (
  <div className="step-layout">
    <Typography variant="h2">{title}</Typography>
    <div className="step-layout-content">{children}</div>
    <ButtonPrimary onClick={buttonAction}>{buttonText}</ButtonPrimary>
  </div>
)

export default SettingsPageLayout
